import React from "react";

function timeAgo(datetime, action) {
  const now = new Date();
  let past = new Date(datetime);
  if(typeof datetime === "string"){
    past = new Date(datetime.replace(" ", "T") + "Z");
  }
  const diff = Math.floor((now - past) / 1000); // in seconds

  if (diff < 60) return `${action} ${diff}s ago`;
  if (diff < 3600) return `${action} ${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${action} ${Math.floor(diff / 3600)}h ago`;
  if (diff < 172800) return `${action} 1 day ago`;

  return `Last fetched on ${past.toLocaleDateString()}`;
}

export const LastFetchedAt = ({ timestamp, action='refreshed'  }) => {
  if (!timestamp) return null;

  return (
    <span className="text-sm text-gray-500">
      {timeAgo(timestamp, action)}
    </span>
  );
}
